import { render, staticRenderFns } from "./app-tabs.component.vue?vue&type=template&id=159afaca"
import script from "./app-tabs.component.vue?vue&type=script&lang=js"
export * from "./app-tabs.component.vue?vue&type=script&lang=js"
import style0 from "./app-tabs.component.vue?vue&type=style&index=0&id=159afaca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports